import { Paper } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useMemo, useReducer } from 'react';
import { JupiterTheme } from '../../../../theme/types';
import icon from '../../../../util/icon';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    iconContainer: {
      alignItems: 'center',
      background: 'none',
      boxShadow: 'none',
      color: theme.palette.coolGrey[400],
      display: 'flex',
      fill: 'none',
      minHeight: 72,
      justifyContent: 'center',
      minWidth: '150px',
      '& svg': {
        strokeWidth: 1,
      },
    },
    disabled: {
      color: theme.palette.coolGrey[200],
    },
  })
);

export interface Props {
  className: string;
  disabled?: boolean;
}

const Tile = ({ className, disabled = false }: Props) => {
  const classes = useStyles();
  const path = useMemo(() => icon.classToPath(className), [className]);
  const ClassIcon = icon.get(path);
  const [renderCount, forceUpdate] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const hackIcon = async () => {
      // Icon.load returns inconsistent results but is required to load the icon
      await icon.load(path); // This updates the return of icon.get
      forceUpdate(); // we don't want to store redundant state, just re-render once
    };
    void hackIcon();
  }, [path]);

  return (
    <Paper
      data-testid={renderCount ? 'Tile-loaded' : 'Tile-loading'}
      className={clsx(classes.iconContainer, disabled && classes.disabled)}
    >
      <ClassIcon size={44} />
    </Paper>
  );
};

export default Tile;
